const MORNING = () => {
  //Time from 6:00am - 11:30am
  const times = [];
  for (let i = 6; i < 12; i++) {
    let hours = i;
    if (hours === 0) {
      hours = 12;
    }
    let minutes = "00";
    let ampm = "am";

    let time = hours + ":" + minutes + ampm;
    times.push(time);

    minutes = "30";
    time = hours + ":" + minutes + ampm;
    times.push(time);
  }
  return times;
};

const AFTERNOON = () => {
  //Time from 12:00pm - 5:30pm
  const times = [];

  for (let i = 12; i < 18; i++) {
    let hours = i;
    if (hours > 12) {
      hours -= 12;
    }
    let minutes = "00";
    let ampm = "pm";

    let time = hours + ":" + minutes + ampm;
    times.push(time);

    minutes = "30";
    time = hours + ":" + minutes + ampm;
    times.push(time);
  }
  return times;
};

const EVENING = () => {
  //Time from 06:00pm - 11:30pm
  const times = [];
  for (let i = 18; i < 24; i++) {
    let hours = i;
    if (hours > 12) {
      hours -= 12;
    }
    let minutes = "00";
    let ampm = "pm";

    let time = hours + ":" + minutes + ampm;
    times.push(time);

    minutes = "30";
    time = hours + ":" + minutes + ampm;
    times.push(time);
  }
  return times;
};

const EVENING2 = () => {
  //Time from 12:00am - 05:30am
  const times = [];
  for (let i = 0; i < 6; i++) {
    for (let j = 0; j < 2; j++) {
      let hour = i % 12;
      let ampm = "am";
      if (hour === 0) {
        hour = 12;
      }
      let minute = j === 0 ? "00" : "30";
      let time = hour + ":" + minute + ampm;
      times.push(time);
    }
  }
  return times;
};

const TRAININGTIMES = () => {
  const times = [];
  
  // Generate times for the full 24-hour period (0-23 hours)
  for (let hours = 0; hours < 24; hours++) {
    let m = hours >= 12 ? 'PM' : 'AM';
    let hour = hours;
    
    // Convert 24-hour format to 12-hour format
    if (hours === 0) {
      hour = 12; // 12am
    } else if (hours > 12) {
      hour = hours % 12;
    }
    
    // Generate 15-minute intervals for each hour
    for (let minutes = 0; minutes < 60; minutes += 15) {
      let time = `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}${m}`;
      times.push(time);
    }
  }

  return times;
};

module.exports = {
  MORNING,
  EVENING,
  AFTERNOON,
  EVENING2,
  TRAININGTIMES,
};
